import React, { useState } from 'react';

const LabeledInputWithDropdown = ({ label, value, setValue, options = [], isValid }) => {
    const [showDropdown, setShowDropdown] = useState(false);

    return (
        <div style={{position: 'relative', margin: '5px 0'}}>
            <label style={{display: 'block', marginBottom: '2px'}}>{label}</label>
            <div style={{display: 'flex'}}>
                <input
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    placeholder={label}
                    style={{
                        width: 'calc(100% - 30px)',
                        backgroundColor: isValid ? '#d4edda' : 'white'
                    }}
                />
                <button onClick={() => setShowDropdown(!showDropdown)} style={{marginLeft: '5px'}}>▼</button>
            </div>
            {showDropdown && (
                <div style={{position: 'absolute', zIndex: 1, backgroundColor: 'white', border: '1px solid #ccc'}}>
                    {options.map((item, idx) => (
                        <div
                            key={idx}
                            onClick={() => {
                                setValue(item);
                                setShowDropdown(false);
                            }}
                            style={{padding: '4px 8px', cursor: 'pointer'}}
                        >
                            {item}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LabeledInputWithDropdown;
